import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import { saveReferralCallForm } from "../../../service/Referral/action";
import SitesCallingForm from "./sitesCallingForm";


const mapStateToProps = (state) => ({
    referralCallForm:state.Referral.referralCallForm,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            saveReferralCallForm
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(SitesCallingForm);
